import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { RechtControllerService, RechtDTO } from '../../../target/generated-sources/openapi';

@Injectable({
  providedIn: 'root'
})
export class RechtListResolver implements Resolve<RechtDTO[]> {

  constructor(private backend: RechtControllerService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<RechtDTO[]> {
    return this.backend.getRechtList();
  }

}
